import React, { useState } from 'react';
import { SEO } from '../components/SEO';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { AboutSection } from '../components/AboutSection';
import { ExperiencesSection } from '../components/ExperiencesSection';
import { DestinationsSection } from '../components/DestinationsSection';
import { SustainabilitySection } from '../components/SustainabilitySection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ClientsSection } from '../components/ClientsSection';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
import { RequestItineraryForm } from '../components/RequestItineraryForm';

export const HomePage = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleStartJourney = () => {
    scrollToSection('experiences');
  };

  const handleRequestItinerary = () => {
    setIsFormOpen(true);
  };

  return (
    <div className="min-h-screen">
      <SEO 
        title="Peace of Mind Trips | Explore India with Heart"
        description="Peace of Mind Trips offers authentic travel experiences across India—heritage walks, cultural journeys, wellness retreats, and meaningful local connections."
        canonical="/"
      />
      <Header onRequestItinerary={handleRequestItinerary} />
      <HeroSection onStartJourney={handleStartJourney} />
      <AboutSection />
      <ExperiencesSection />
      <DestinationsSection />
      <SustainabilitySection />
      <TestimonialsSection />
      <ClientsSection />
      <CTASection onPlanWithUs={handleRequestItinerary} />
      <Footer />
      <RequestItineraryForm isOpen={isFormOpen} onClose={() => setIsFormOpen(false)} />
    </div>
  );
};